<!-- Optional top banner -->
<app-cms-banner-section
  *ngIf="topBanner"
  class="block mb-6"
  [banner]="topBanner"
>
</app-cms-banner-section>

<ul
  class="search-results__list"
  *ngIf="!isLoading && isActivitiesPagination"
  data-test="search-items"
>
  <li
    *ngFor="let item of items"
    onKeyPres
    onKeyDown
    onKeyUp
    (click)="getScrollPosition()"
  >
    <a [routerLink]="getPath(item) | localize" [attr.aria-label]="item.name">
      <!-- Activities results -->
      <app-attendee-activity-card
        *ngIf="isActivitiesPagination"
        [activity]="item"
      ></app-attendee-activity-card>
    </a>
  </li>
</ul>

<!-- Timeslots results -->
<ng-container class="search-results__list" *ngIf="!isActivitiesPagination">
  <ng-container *ngFor="let eventGroup of items">
    <h2 class="font-bold title-5 lg:text-3xl mt-4 mb-4 capitalize">
      {{ formatDate(eventGroup?.date) }}
    </h2>

    <ul *ngIf="eventGroup.events?.length">
      <li
        *ngFor="let event of eventGroup.events; let isFirst = first"
        [class.mt-3]="!isFirst"
        class="search-results__list__link"
      >
        <app-attendee-live-card
          [activity]="event.activity"
          [timeslot]="event.timeslot"
          [isMobileDevice]="isMobileDevice"
        >
        </app-attendee-live-card>
      </li>
    </ul>
  </ng-container>
</ng-container>

<!-- no-results -->
<ng-container *ngIf="items && items?.length === 0 && !isLoading">
  <!-- no-results alert -->
  <app-tips
    class="block w-full mt-4"
    [icon]="iconTypeEnum.Information"
    [variant]="tipsVariant.WARNING"
    [title]="'search.no_results.title' | translate"
    [tips]="'search.no_results.description' | translate"
  >
  </app-tips>

  <!-- no-results reset filter -->
  <button
    app-vtmn-play-button
    type="button"
    [variant]="vtmnPlayButtonVariant.SECONDARY"
    class="w-full mt-5 md:w-auto"
    (click)="resetFilters()"
  >
    {{ 'search.no_results.reset_filters' | translate }}
  </button>
</ng-container>

<!-- Optional bottom banner -->
<app-cms-banner-section
  *ngIf="bottomBanner"
  class="block -mb-5 -mx-3 xs:-mx-6 sm:-mx-9 lg:-mb-8"
  [banner]="bottomBanner"
>
</app-cms-banner-section>
